import { Component, inject } from '@angular/core';
import { CardContainerComponent } from 'src/app/components/card-container/card-container.component';
import { DataDogService } from 'src/app/configuration/datadog/services/data-dog.service';
import {
  AttributeTypeEnum,
  CustomKeyEnum,
} from 'src/app/configuration/enums/tracking-data-dog.enum';

@Component({
  selector: 'app-serasa-premium',
  template: `
    <app-card-container>
      <div class="d-flex flex-column gap-3">
        <header>
          <h2 class="title-mobile-medium">Serasa Premium</h2>
          <p class="body-regular">Tenha mais controle sobre seus dados</p>
        </header>
        <p class="body-regular">
          Seja Premium e receba alertas sobre seu CPF e CNPJ, monitore seu Serasa Score e aumente
          sua proteção contra fraudes.
        </p>
        <footer class="d-flex justify-content-between">
          <span class="caption-highlight available-signature"> Assinatura disponível </span>
          <a (click)="openLink()" class="body-m-bold a-more-info">
            Saiba mais
            <i class="bi bi-chevron-right"></i>
          </a>
        </footer>
      </div>
    </app-card-container>
  `,
  styles: [
    `
      @import '../../../../../app/colors.scss';
      :host {
        display: block;
        padding: 1.25rem;
      }

      div > p {
        color: var(--color-text-title);
      }

      header > p {
        color: #d82b80;
      }

      footer {
        span {
          padding: 4px 8px;
          background-color: #d82b80;
          border-radius: 4px;
          color: #fff;
        }

        a {
          color: #425ccb;
        }
      }
    `,
  ],
  imports: [CardContainerComponent],
})
export class SerasaPremiumComponent {
  private datadogService = inject(DataDogService);
  openLink() {
    this.datadogService.createTrackingAttribute(
      AttributeTypeEnum.UserClickedInSeraPremiumOffer,
      CustomKeyEnum.Serasa
    );
    window.open('https://www.serasa.com.br/premium/checkout', '_blank');
  }
}
